import { Component, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'md-grid-icon',
  imports: [MatIcon],
  templateUrl: './grid-icon.component.html',
  styleUrl: './grid-icon.component.scss',
  standalone: true
})
export class GridIconComponent implements ICellRendererAngularComp {
  value = signal('');
  icon = signal('');
  agInit(params: ICellRendererParams & { icon: string }): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams & { icon: string }): boolean {
    this.value.set(params.value);
    this.icon.set(params.icon);
    return true;
  }
}
